import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';
import { isTauri } from '@/tauri/utils';

import { GDT_FEATURE_FLAG } from '@heidi/integrations/ehr/contracts';
import { useGdtLaunchComplete } from '../hooks/useGdtLaunchComplete';

/**
 * Inner component that calls the hook.
 * Separated so the hook only mounts when GDT is enabled.
 */
function GdtLaunchListener() {
  useGdtLaunchComplete();
  return null;
}

/**
 * Hidden component that listens for GDT patient launch events
 * and auto-creates sessions.
 *
 * Mount once at the app level (e.g., in AuthWrapper).
 * Renders nothing — it only runs the useGdtLaunchComplete hook.
 *
 * Guards:
 * - Only active in Tauri desktop apps
 * - Only active when GDT feature flag is enabled
 *
 * Uses useFeatureFlagEnabled (reactive) instead of a static flag check so
 * the listener mounts correctly even when PostHog initializes after first render.
 */
export function GdtLauncher() {
  const isGdtEnabled = useFeatureFlagEnabled(GDT_FEATURE_FLAG);

  // Only active in Tauri desktop builds and when the feature flag is on.
  // useFeatureFlagEnabled returns undefined while PostHog is loading — treat as disabled.
  if (!isTauri() || !isGdtEnabled) {
    return null;
  }

  return <GdtLaunchListener />;
}
